import { render, staticRenderFns } from "./AddFleet.vue?vue&type=template&id=059ca596&"
import script from "./AddFleet.vue?vue&type=script&lang=js&"
export * from "./AddFleet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports